export const isDev = process.env.ENVIRONMENT === 'dev';
